import { Typography } from "@mui/material"
import type { FC, ReactNode } from "react"
import { twMerge } from "tailwind-merge"

interface SectionHeadingProps {
  children: ReactNode
  className?: string
}

export const SectionHeading: FC<SectionHeadingProps> = ({ children, className }) => {
  return (
    <Typography variant='subtitle1' className={twMerge("mb-3 font-normal text-gray-900", className)}>
      {children}
    </Typography>
  )
}
